import { render } from "./ServicoComponent.vue?vue&type=template&id=6dd6059c&scoped=true"
import script from "./ServicoComponent.vue?vue&type=script&lang=js"
export * from "./ServicoComponent.vue?vue&type=script&lang=js"

import "./ServicoComponent.vue?vue&type=style&index=0&id=6dd6059c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd6059c"]])

export default __exports__